var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"va-audio-file-input"},[_c('v-file-input',{attrs:{"value":_vm.file,"loading":_vm.loading,"label":_vm.label,"accept":".mp3, .wav"},on:{"change":_vm.fileChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }